export { useInstagramMedia, type UseInstagramMediaOptions } from "@/hooks/instagramMedia/useInstagramMedia";

